import {Context, createContext, useEffect, useState} from "react";
import {useBackButton} from "@tma.js/sdk-react";

export type BackButtonFunction = {
    fn: () => void,
    id: string
}

export let AddBackButtonAction: Context<(entry: BackButtonFunction) => void>
export let SetRootBackButtonAction: Context<(entry: BackButtonFunction | null) => void>

export function BackButtonProvider({children} : {children : JSX.Element}) {
    const backButton = useBackButton()
    const [stack, setStack] = useState([] as BackButtonFunction[])
    const [prevHandleClick, setPrevHandleClick] = useState<(() => void) | null>(null)
    const addEntry = (entry : BackButtonFunction) => {
        console.log(entry.id)
        backButton.show()
        const newStack = [...stack, entry]
        setStack(newStack)
    }

    const setFirstElement = (entry : BackButtonFunction | null) => {
        if (entry === null) {
            if (stack[0]?.id === "go-to-main") {
                if (stack.length === 1) backButton.hide()
                setStack([...stack.slice(1)]);
            }
            return;
        }
        backButton.show()
        if (stack[0]?.id !== entry?.id) {
            setStack([entry, ...stack]);
            return;
        }
        const newStack = [...stack];
        stack[0] = entry;
        setStack(newStack);
    }

    AddBackButtonAction = createContext(addEntry)
    SetRootBackButtonAction = createContext(setFirstElement)

    const handleClick = () => {
        const newStack = [...stack]
        if (newStack.length === 0) return;
        if (newStack.length === 1) backButton.hide();

        const lastElement = newStack.pop();
        lastElement!.fn()

        setStack(newStack)
    }

    useEffect(() => {
        if (prevHandleClick) backButton.off("click", prevHandleClick)
        backButton.on("click", handleClick);
        setPrevHandleClick(_ => handleClick)
    }, [stack]); // eslint-disable-line react-hooks/exhaustive-deps

    return children;
}